import { BaseService } from '@/core/base-service';

export default class DocumentTypeService extends BaseService<any> {
	public constructor() {
		super('services/servicezef/api/document-type');
	}
}
